import { IRegEdSubmissionView } from '@Queries/RegEdCompliance';
import * as Api from '@ViewModels';
import { LocationDescriptorObject } from 'history';
import { ILocationState } from '../../../models';

/**
 * Builds the location for a revise-and-resubmit draft of a rejected campaign. A rejected piece goes
 * terminal server-side, so a revision is always a fresh campaign carrying the prior approval-request
 * id — never an edit of the rejected one.
 *
 * Passes the campaign itself rather than copied fields: the route hydrates the composer from it, which
 * is the only way the hand-picked recipients and their per-contact messages come across.
 *
 * Returns the location rather than navigating: the target is a fullscreen-modal route, so a caller
 * already inside that modal pushes it on `useHistory()` while one in the app router must push it on
 * `fullscreenModal.history`.
 */
export const buildRegEdEmailReviseLocation = (
	campaign: Api.CampaignViewModel,
	submission: IRegEdSubmissionView
): LocationDescriptorObject => {
	const state: ILocationState<Api.CampaignViewModel, any> = {
		viewModel: campaign,
		model: {
			regEdRevise: {
				revisesApprovalRequestId: submission.approvalRequestId,
				format: submission.metadata?.format,
				answers: submission.metadata?.answers,
			},
		},
	};
	return { pathname: '/email/campaigns/create/from-reged-revision', state };
};
